import { useQuery } from '@tanstack/react-query';

import { diseaseCodeApi } from '../api/disease-code.adapter';
import { diseaseCodeQueryKeys } from './use-disease-groups';

// Fetches the back-references (linked PRO items + deployment modules) for a
// single code. Disabled while no code row is selected.
// v9: codeId is number (BIGINT UNSIGNED).
export function useDiseaseCodeRefsQuery(codeId: number | null) {
  return useQuery({
    queryKey: diseaseCodeQueryKeys.refs(codeId ?? -1),
    queryFn: () => diseaseCodeApi.getCodeReferences(codeId as number),
    enabled: codeId !== null,
    // The reference data changes only when PRO Item / Deployment Module wiring
    // changes — keep it warm for a minute so re-selecting a row is instant.
    staleTime: 60 * 1000,
  });
}
